import React from "react"
import { motion } from 'framer-motion'
import loginSide from '../../Assets/Images/loginSide.png'
import FieldInput from '../../Components/FieldInput'
import * as Yup from 'yup'
import { useFormik } from "formik"
import Button from "../../Components/Button"
import { FiLogIn } from "react-icons/fi";
import { useHistory } from "react-router-dom"
import API from "../../Common/API"
import { useDispatch } from "react-redux"
import { setAlert } from "../../Store/Theme/actions"
import { setAccountType, setLoggedIn, setToken, setUserDetails } from "../../Store/Auth/actions"

const initialLoginForm = {
    userName: '',
    password: ''
}

const Login = () => {


    const history = useHistory()
    const dispatch = useDispatch();

    const loginFormSchema = Yup.object().shape({
        userName: Yup.string().required("User name is required"),
        password: Yup.string().required("Password is required")
    })

    const loginForm = useFormik({
        initialValues: initialLoginForm,
        validateOnMount: true,
        validationSchema: loginFormSchema,
        enableReinitialize: true,
        onSubmit: (values) => {
            try {
                API.post('/auth/login', values).then(async (apiRes) => {
                    if (apiRes.status === 200) {
                        let userDetails = await JSON.parse(window.atob(apiRes.data.data.split(".")[1]));
                        if (userDetails.role === 'Super_Admin') {
                            localStorage.setItem('token', apiRes.data.data)
                            dispatch(setUserDetails(userDetails))
                            dispatch(setAccountType('user'))
                            dispatch(setToken(apiRes.data.data))
                            dispatch(setLoggedIn(true))
                            history.push('/')
                        } else {
                            dispatch(setAlert({ title: 'Error', subtitle: 'Users are not permitted to login here', type: 'error', active: true }))
                        }
                    }
                })
            } catch (err) {

            }
        }
    })

    return (
        <motion.div className="min-h-screen w-full flex flex-col justify-center items-center text-center">
            <motion.div className="h-full w-full flex flex-row justify-between gap-2">
                <div className="w-full lg:w-1/2 flex flex-col justify-center items-start px-20">
                    <h1 className="text-2xl font-bold text-primeColor mb-4 px-5">Welcome Back!</h1>
                    <p className="text-black mb-6 px-5">Login to get unlimited access and get your bride</p>
                    <motion.div className="grid grid-cols-1 w-full gap-5">
                        <FieldInput outerInjectClass={'w-full'} label={'User Name'} fieldProps={loginForm.getFieldProps('userName')} fieldHelper={loginForm.getFieldHelpers('userName')} fieldMeta={loginForm.getFieldMeta('userName')} edit={true} dataLoaded={true} />
                        <FieldInput type="password" outerInjectClass={'w-full'} label={'Password'} fieldProps={loginForm.getFieldProps('password')} fieldHelper={loginForm.getFieldHelpers('password')} fieldMeta={loginForm.getFieldMeta('password')} edit={true} dataLoaded={true} />
                        <motion.div className="w-full flex flex-row px-5 justify-between">
                            <motion.div className="w-full flex flex-row justify-start items-center">
                                <input type="checkbox" className="mx-2" />
                                <p>Remember Me</p>
                            </motion.div>
                            <motion.div className="text-md w-full cursor-pointer text-primeColor flex flex-row justify-end font-bold">
                                Forgot Password?
                            </motion.div>
                        </motion.div>
                        <Button type="primary" injectClass={'flex items-center text-center justify-center flex-row w-full'} onClick={() => loginForm.submitForm()}>
                            <FiLogIn /> &nbsp;Login</Button>
                        <motion.div className="flex flex-row w-full justify-start px-2">
                            <p className="font-bold">Don't have an account?</p>&nbsp;
                            <p className="text-primeColor underline cursor-pointer" onClick={() => history.push('/auth/register')}>Create one</p>
                        </motion.div>
                    </motion.div>
                </div>
                <div className="hidden lg:flex w-1/2 h-screen relative">
                    <img
                        src={loginSide}
                        alt="Login Side"
                        className="w-full h-full object-cover"
                    />
                    <div className="absolute bottom-4 left-4 w-full rounded-md  p-4">
                        <h2 className="text-blue-900 font-bold">Logo Here</h2>
                        <p className="text-gray-700">Caption here</p>
                    </div>
                </div>
            </motion.div>
        </motion.div>
    )
}

export default Login